import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { suggestContact } from 'actions/storylet';

import Loading from 'components/Loading';

export class SuggestContactButton extends Component {
  mounted = false

  state = {
    isWaitingForSuggestion: false,
  }

  componentDidMount = () => {
    this.mounted = true;
  }

  componentWillUnmount = () => {
    this.mounted = false;
  }

  handleClick = async () => {
    const {
      branchId,
      dispatch,
      onSuggestComplete,
    } = this.props;
    this.setState({ isWaitingForSuggestion: true });
    try {
      // Make the request
      const data = await dispatch(suggestContact(branchId));
      // Pass the response to our parent
      onSuggestComplete(data);
    } catch (error) {
      console.error(error);
    } finally {
      this.setStateIfMounted({ isWaitingForSuggestion: false });
    }
  }

  setStateIfMounted = (state) => {
    if (this.mounted) {
      this.setState(state);
    }
  }

  render = () => {
    const { isWaitingForSuggestion } = this.state;

    return (
      <button
        className="button button--tertiary button--no-margin"
        disabled={isWaitingForSuggestion}
        onClick={this.handleClick}
        type="button"
      >
        {isWaitingForSuggestion ? <Loading spinner small /> : 'Suggest a contact'}
      </button>
    );
  }
}

SuggestContactButton.propTypes = {
  onSuggestComplete: PropTypes.func.isRequired,
};

export default connect()(SuggestContactButton);